import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconBarSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="barSolid">
            <path
                d="M19.0003 3C19.3925 3.00011 19.7484 3.22973 19.9105 3.58691C20.0725 3.944 20.0112 4.36297 19.7532 4.6582L13.0003 12.375V19H16.0003C16.5525 19.0002 17.0003 19.4478 17.0003 20C17.0003 20.5522 16.5525 20.9998 16.0003 21H8.00031C7.44803 21 7.00031 20.5523 7.00031 20C7.00031 19.4477 7.44803 19 8.00031 19H11.0003V12.375L4.24738 4.6582C3.98926 4.36293 3.92808 3.94409 4.09016 3.58691C4.25233 3.22971 4.608 3 5.00031 3H19.0003Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
